









































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  GetActivitiesDtosPrivacyOptions,
  GetActivitiesDtosPeriodOptions
} from "@/server/app.queries";

@Component
export default class ActivitiesMenuFilters extends Vue {
  period: any = null;
  privacy: any = null;
  // ignoreRender: boolean = true;
  privacyOptions: any[] = [];
  periodOptions: any[] = [];

  constructor() {
    super();
    Object.keys(GetActivitiesDtosPrivacyOptions)
      .filter(
        (key: any) => !isNaN(Number(GetActivitiesDtosPrivacyOptions[key]))
      )
      .forEach((key: any) =>
        this.privacyOptions.push({
          title: key,
          value: GetActivitiesDtosPrivacyOptions[key]
        })
      );

    Object.keys(GetActivitiesDtosPeriodOptions)
      .filter((key: any) => !isNaN(Number(GetActivitiesDtosPeriodOptions[key])))
      .forEach((key: any) => {
        this.periodOptions.push({
          title: key,
          value: Number(GetActivitiesDtosPeriodOptions[key])
        });
      });

    this.period = this.$route.query.period
      ? Number(this.$route.query.period)
      : null;
    this.privacy = this.$route.query.privacy
      ? Number(this.$route.query.privacy)
      : null;
  }

  @Watch("period")
  @Watch("orderBy")
  @Watch("privacy")
  onChanged() {
    // if (this.ignoreRender) {
    //   this.ignoreRender = false;
    //   return;
    // }
    const p = Object.assign({}, this.$route.query, {
      skip: 0,
      period: this.period,
      privacy: this.privacy
    });
    this.$router.push({ query: p });
  }
}
